import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=09479bd0&"
import script from "./SettingDialog.vue?vue&type=script&lang=js&"
export * from "./SettingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports